export default {
  videos: state => state.videos,
  marketSegments: state => state.marketSegments,
  incompleteVideosCount: (state) => state.incompleteVideosCount
}



// WEBPACK FOOTER //
// ./src/store/modules/video/getters.js